// extracted by mini-css-extract-plugin
export var divider = "_op-0";
export var systemMessage = "_op-1";